import axios from './axiosConfig'; // Axios avec gestion auto du refresh token
import NotificationService from './NotificationService';

const API_URL = `${process.env.REACT_APP_API_URL || 'http://api.local.dev:8080'}/api/shop`;

class ProductService {
  // Récupérer tous les produits
  static async getProducts() {
    try {
      const response = await axios.get(`${API_URL}/products/list`);
      return response.data;
    } catch (error) {
      NotificationService.error('Erreur lors du chargement des produits');
      console.error('Error fetching products:', error);
      return [];
    }
  }

  // Récupérer un produit par son ID
  static async getProduct(id) {
    try {
      const response = await axios.get(`${API_URL}/products/get/${id}`);
      return response.data.data;
    } catch (error) {
      NotificationService.error('Erreur lors du chargement du produit');
      console.error(`Error fetching product ${id}:`, error);
      return null;
    }
  }

  // Créer un nouveau produit
  static async createProduct(productData) {
    try {
      const response = await axios.post(`${API_URL}/products/save`, productData);
      NotificationService.success('Produit créé avec succès');
      return response.data.data;
    } catch (error) {
      NotificationService.error('Erreur lors de la création du produit');
      console.error('Error creating product:', error);
      throw error;
    }
  }

  // Mettre à jour un produit
  static async updateProduct(id, productData) {
    try {
      const response = await axios.post(`${API_URL}/products/update/${id}`, productData);
      NotificationService.success('Produit mis à jour avec succès');
      return response.data.data;
    } catch (error) {
      NotificationService.error('Erreur lors de la mise à jour du produit');
      console.error(`Error updating product ${id}:`, error);
      throw error;
    }
  }

  // Supprimer un produit
  static async deleteProduct(id) {
    try {
      await axios.post(`${API_URL}/products/delete/${id}`);
      NotificationService.success('Produit supprimé avec succès');
      return true;
    } catch (error) {
      NotificationService.error('Erreur lors de la suppression du produit');
      console.error(`Error deleting product ${id}:`, error);
      throw error;
    }
  }

  static async setFeaturedProducts(productIds) {
    try {
      const response = await axios.post(`${API_URL}/products/featured`, {
        product_ids: productIds,
      });
      NotificationService.success('Produits mis en avant mis à jour');
      return response.data.data || [];
    } catch (error) {
      NotificationService.error(
        error.response?.data?.error || 'Erreur lors de la mise à jour des produits mis en avant'
      );
      console.error('Error updating featured products:', error);
      throw error;
    }
  }

  // Récupérer un produit par son ID
  static async getProductById(id) {
    try {
      const response = await axios.get(`${API_URL}/products/get/${id}`);
      return response.data.data;
    } catch (error) {
      NotificationService.error('Erreur lors de la récupération du produit');
      console.error(`Error fetching product ${id}:`, error);
      throw error;
    }
  }
}

export default ProductService; 